import { ModalType } from 'helpers/modals';

export const getNdbEmailModal = (isEmailConfirmed: boolean) =>
  isEmailConfirmed
    ? ModalType.ConfirmedEmailForNDBModal
    : ModalType.ConfirmEmailForNDBModal;
